import $ from 'jquery'

/**
 * @param {string} scriptUrl
 * @param {number?} timeoutMs
 * @returns {Promise<void>}
 */
export function loadScript(scriptUrl, timeoutMs = 5000) {
  return new Promise((resolve, reject) => {
    let scriptTag = document.createElement('script')
    scriptTag.src = scriptUrl

    let timerID = setTimeout(() => {
      reject({
        status: 'error',
        message: `Timeout loading script ${scriptUrl}`,
      })
    }, timeoutMs)

    scriptTag.onerror = () => {
      clearTimeout(timerID)
      reject({
        status: 'error',
        message: `Error loading ${scriptUrl}`,
      })
    }

    scriptTag.onload = () => {
      clearTimeout(timerID)
      resolve()
    }

    document.head.appendChild(scriptTag)
  })
}

/**
 * @param {string[]} scripts
 * @param {(() => Promise<void>)?} onLoaded
 * @returns {Promise<void>}
 */
export function getReactScriptsLoader(scripts = [], onLoaded = undefined) {
  const allScripts = ['/dist/react.common.js', ...scripts]

  let inited = false
  async function initScripts() {
    if (!inited) {
      inited = true
      for (let scriptUrl of allScripts) {
        if ($(`script[src="${scriptUrl}"]`).length) continue
        await loadScript(scriptUrl)
      }

      if (onLoaded) await onLoaded()
    }
  }

  return initScripts
}
